/** The reads shared by explicit app opening and a reload of its overview. */
export const LIST_OVERVIEW_REQUESTS = {
  patients: [
    '/lists?app_context=patient&include_total=false&page_size=500',
    '/investigator/list-labels',
    '/label-pool?app_context=patient',
  ],
  // Private Lists take labels from the person's own pool (ADR 0080).
  lists: ['/lists/overview', '/label-pool', '/label-pool?scope=personal'],
} as const;
